import {JOB_LIST} from '../testing/TestingDataSH26';

// helper functions

function FilterJobs(type) {
    return JOB_LIST.filter(function (job) {
        return job.designStatus === type;
    })
}

function GetFullList() {
    return JOB_LIST.filter(function (job) {
        return job.designStatus === "NO DESIGNS" || job.designStatus === "DESIGNS UPLOADED" ||
            job.designStatus === "DESIGN CHOSEN" || job.designStatus === "COMPLETE";
    })
}

function GetUncompletedList() {
    return JOB_LIST.filter(function (job) {
        return job.designStatus === "NO DESIGNS" || job.designStatus === "DESIGNS UPLOADED" ||
            job.designStatus === "DESIGN CHOSEN"
    })
}

function FilterJobsYear(type, year) {
    return JOB_LIST.filter(function (job) {
        return job.designStatus === type && new Date(job.dates.enquiryReceived).getFullYear() === year;
    })
}

function FullFilterJobsYear(type1, type2, type3, year) {
    
    return JOB_LIST.filter(function (job) {
        return (job.designStatus === type1 || job.designStatus === type2 ||
            job.designStatus === type3) && new Date(job.dates.enquiryReceived).getFullYear() === year;
    })
}

function FullFilterJobsMonth(type1, type2, type3, year, month) {
    return JOB_LIST.filter(function (job) {
        return (job.designStatus === type1 || job.designStatus === type2 ||
                job.designStatus === type3) && new Date(job.dates.enquiryReceived).getFullYear() === year
            && new Date(job.dates.enquiryReceived).getMonth() === month;
    })
}

function FilterJobsMonth(type, month, year) {
    return JOB_LIST.filter(function (job) {
        return job.designStatus === type && new Date(job.dates.enquiryReceived).getMonth() === month
            && new Date(job.dates.enquiryReceived).getFullYear() === year;
    })
}

function countJobs() {
    const date = new Date();
    const year = date.getFullYear();
    const month = date.getMonth();
    return {
        currentJobCountYear: FullFilterJobsYear("NO DESIGNS", "DESIGNS UPLOADED", "DESIGN CHOSEN", year).length,
        completeJobCountYear: FilterJobsYear("COMPLETE", year).length,

        currentJobCountMonth: FullFilterJobsMonth("NO DESIGNS", "DESIGNS UPLOADED", "DESIGN CHOSEN", year, month).length,
        completeJobCountMonth: FilterJobsMonth("COMPLETE", month, year).length,
    }
}


// reducers
export function jobCountSkimReducer(state = countJobs(), action) {
    switch (action.type) {
        case 'jobCountSkimReducer/UPDATE':
            return countJobs();
        default:
            return state;
    }
}

export function SortReducerIncomplete(state, action) {
    switch (action.type) {
        case 'design/jobSort/SORT_NEW':
            let jobsList = GetUncompletedList();
            jobsList.sort((job1, job2) =>
                (job1.dates.enquiryReceived > job2.dates.enquiryReceived) ? 1 :
                    (job1.dates.enquiryReceived < job2.dates.enquiryReceived) ? -1 : 0);
            
            return jobsList;
        case 'design/jobSort/SORT_OLD':
            let jobsListOldest = GetUncompletedList();
            jobsListOldest.sort((job1, job2) =>
                (job1.dates.enquiryReceived < job2.dates.enquiryReceived) ? 1 :
                    (job1.dates.enquiryReceived > job2.dates.enquiryReceived) ? -1 : 0);
            return jobsListOldest;
        case 'design/jobSort/SORT_AZ':
            let jobsListAZ = GetUncompletedList();
            jobsListAZ.sort((job1, job2) =>
                (job1.name > job2.name) ? 1 : (job1.name < job2.name) ? -1 : 0);
            return jobsListAZ;
        default:
            return GetUncompletedList();
    }
}


export function SortReducerComplete(state, action, jobType) {
    switch (action.type) {
        case 'design/jobSort/SORT_NEW':
            let jobsListNew = FilterJobs("COMPLETE");
            jobsListNew.sort((job1, job2) =>
                (job1.dates.enquiryReceived > job2.dates.enquiryReceived) ? 1 :
                    (job1.dates.enquiryReceived < job2.dates.enquiryReceived) ? -1 : 0);
            return jobsListNew;
        case 'design/jobSort/SORT_OLD':
            let jobsListOldest = FilterJobs("COMPLETE");
            jobsListOldest.sort((job1, job2) =>
                (job1.dates.enquiryReceived < job2.dates.enquiryReceived) ? 1 :
                    (job1.dates.enquiryReceived > job2.dates.enquiryReceived) ? -1 : 0);
            return jobsListOldest;
        case 'design/jobSort/SORT_AZ':
            let jobsListAZ = FilterJobs("COMPLETE");
            jobsListAZ.sort((job1, job2) =>
                (job1.name > job2.name) ? 1 : (job1.name < job2.name) ? -1 : 0);
            return jobsListAZ;
        default:
            return FilterJobs("COMPLETE");
    }
}

export function SortReducerFull(state, action, jobType) {
    switch (action.type) {
        case 'design/jobSort/SORT_NEW':
            let jobsListNew = GetFullList();
            jobsListNew.sort((job1, job2) =>
                (job1.dates.enquiryReceived > job2.dates.enquiryReceived) ? 1 :
                    (job1.dates.enquiryReceived < job2.dates.enquiryReceived) ? -1 : 0);
            return jobsListNew;
        case 'design/jobSort/SORT_OLD':
            let jobsListOldest = GetFullList();
            jobsListOldest.sort((job1, job2) =>
                (job1.dates.enquiryReceived < job2.dates.enquiryReceived) ? 1 :
                    (job1.dates.enquiryReceived > job2.dates.enquiryReceived) ? -1 : 0);
            return jobsListOldest;
        case 'design/jobSort/SORT_AZ':
            let jobsListAZ = GetFullList();
            jobsListAZ.sort((job1, job2) =>
                (job1.name > job2.name) ? 1 : (job1.name < job2.name) ? -1 : 0);
            return jobsListAZ;
        default:
            return GetFullList();
    }
}


export function SearchReducerNew(state = "search", action) {
    switch (action.type) {
        case 'design/new/SEARCH': {
            let returnList = []
            let jobs = GetUncompletedList();
            for (const job in jobs) {
                if (jobs[job].name.toUpperCase().includes(action.term.toUpperCase())) {
                    returnList.push(jobs[job]);
                } else if (jobs[job].id.includes(action.term)) {
                    returnList.push(jobs[job]);
                }
            }

            if (returnList.length === 0) {
                const message = "'" + action.term + "' didn't match any jobs";
                return message;
            }
            return returnList;
        }
        default:
            return [];
    }
}

export function SearchReducerComplete(state = "search", action) {
    switch (action.type) {
        case 'design/complete/SEARCH': {
            let returnList = []
            let jobs = FilterJobs("COMPLETE")
            for (const job in jobs) {
                if (jobs[job].name.toUpperCase().includes(action.term.toUpperCase())) {
                    returnList.push(jobs[job]);
                } else if (jobs[job].id.includes(action.term)) {
                    returnList.push(jobs[job]);
                }
            }

            if (returnList.length === 0) {
                const message = "'" + action.term + "' didn't match any jobs";
                return message;
            }
            return returnList;
        }
        default:
            return [];
    }
}

export function SearchReducerFull(state = "search", action) {
    switch (action.type) {
        case 'design/full/SEARCH': {
            let returnList = []
            let jobs = GetFullList();
            for (const job in jobs) {
                if (jobs[job].name.toUpperCase().includes(action.term.toUpperCase())) {
                    returnList.push(jobs[job]);
                } else if (jobs[job].id.includes(action.term)) {
                    returnList.push(jobs[job]);
                }
            }

            if (returnList.length === 0) {
                const message = "'" + action.term + "' didn't match any jobs";
                return message;
            }
            return returnList;
        }
        default:
            return [];
    }
}


export function filterReducerNew(state = "none", action) {
    switch (action.type) {
        case 'design/FILTER': {
            const filter = action.filterBy;
            let returnList = []
            let jobs = GetUncompletedList();
            for (const job in jobs) {
                if (jobs[job].designStatus === filter) {
                    returnList.push(jobs[job]);
                }
            }
            if (returnList.length === 0) {
                const message = "filtering by'" + filter + "' didn't match any jobs";
                return message;
            }
            return returnList;
        }
        default:
            return [];
    }
}

export function filterReducerCompleted(state = "none", action) {
    switch (action.type) {
        case 'design/FILTER': {
            const filter = action.filterBy;
            let returnList = []
            let jobs = FilterJobs("COMPLETE")
            for (const job in jobs) {
                if (jobs[job].designStatus === filter) {
                    returnList.push(jobs[job]);
                }
            }
            if (returnList.length === 0) {
                const message = "filtering by'" + filter + "' didn't match any jobs";
                return message;
            }
            return returnList;
        }
        default:
            return [];
    }
}

export function filterReducerFull(state = "none", action) {
    switch (action.type) {
        case 'design/FILTER': {
            const filter = action.filterBy;
            let returnList = []

            let jobs = GetFullList();
            for (const job in jobs) {
                if (jobs[job].designStatus === filter) {
                    returnList.push(jobs[job]);
                }
            }
            if (returnList.length === 0) {
                const message = "filtering by'" + filter + "' didn't match any jobs";
                return message;
            }
            return returnList;
        }
        default:
            return [];
    }
}